import PencePrice from './PencePrice.component';
export default PencePrice;